// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"c1c80cb8","884":"8d7e4b98","889":"82719f06","940":"e4cea079"}[chunkId] + ".chunk.js";
};